import React from 'react'
import { DentalDataSummary } from '@utils/dental-data-summary.utils'
import './DentalChartSummaryContent.css'

interface DentalChartSummaryContentProps {
  summary: DentalDataSummary
  showHeading?: boolean
}

const DentalChartSummaryContent: React.FC<DentalChartSummaryContentProps> = ({
  summary,
  showHeading = true,
}) => {
  return (
    <div className="dental-chart-summary">
      {showHeading && (
        <h6 className="dental-chart-summary__heading">Dental Chart Summary</h6>
      )}
      <p className="dental-chart-summary__total">
        <strong>Total:</strong> {summary.totalTeeth}{' '}
        {summary.totalTeeth === 1 ? 'tooth' : 'teeth'} with conditions
        {summary.totalConditions > 0 && (
          <span>
            {' '}
            ({summary.totalConditions}{' '}
            {summary.totalConditions === 1 ? 'condition' : 'conditions'})
          </span>
        )}
      </p>
      {summary.summary.length > 0 ? (
        <div className="dental-chart-summary__list">
          {summary.summary.map((tooth, toothIndex) => (
            <div
              key={tooth.toothNumber}
              className={`dental-chart-summary__tooth${
                toothIndex < summary.summary.length - 1
                  ? ' dental-chart-summary__tooth--bordered'
                  : ''
              }`}
            >
              <strong>Tooth {tooth.toothNumber}:</strong>
              <ul className="dental-chart-summary__conditions">
                {tooth.conditions.map((condition, idx) => (
                  <li key={idx}>{condition}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      ) : (
        <p className="dental-chart-summary__empty">
          No dental conditions recorded
        </p>
      )}
    </div>
  )
}

export default React.memo(DentalChartSummaryContent)
